import { render } from "./PageGenerateRecipe.vue?vue&type=template&id=bf148a7e&scoped=true"
import script from "./PageGenerateRecipe.vue?vue&type=script&lang=js"
export * from "./PageGenerateRecipe.vue?vue&type=script&lang=js"

import "./PageGenerateRecipe.vue?vue&type=style&index=0&id=bf148a7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf148a7e"]])

export default __exports__